import { useEffect, useState } from "react";
import { Button } from "semantic-ui-react";
import StringEntry from "../../datatypeComponents/StringEntry";

const GroupCriteriaConverter = ({ startingEligibilityCriteria, setResourceState }) => {
    const [criteriaListState, setCriteriaListState] = useState({
        markdown: "Inclusion Criteria:\n* ...\nExclusion Criteria:\n* ..."
    });

    useEffect(() => {
        if (startingEligibilityCriteria) {
            setCriteriaListState({ "markdown": startingEligibilityCriteria });
        }
    }, [startingEligibilityCriteria]);

    const createGroupCharacteristicValues = (markdownList) => {
        let markdownListSplit = markdownList?.split("Exclusion Criteria:");
        let inclusionList = markdownListSplit[0];
        let exclusionList = markdownListSplit[1];
        let inclusionListSplit = inclusionList?.split("* ");
        let exclusionListSplit = exclusionList?.split("* ");
        let groupCharacteristicValue = [];
        if (inclusionListSplit?.length > 1) {
            for (let index in inclusionListSplit) {
                if (index > 0) {
                    groupCharacteristicValue.push({
                        "code": { "text": "Defined by CodeableConcept" },
                        "valueCodeableConcept": { "text": inclusionListSplit[index] },
                        "exclude": false,
                        "description": inclusionListSplit[index]
                    });
                }
            }
        }
        if (exclusionListSplit?.length > 1) {
            for (let index in exclusionListSplit) {
                if (index > 0) {
                    groupCharacteristicValue.push({
                        "code": { "text": "Defined by CodeableConcept" },
                        "valueCodeableConcept": { "text": exclusionListSplit[index] },
                        "exclude": true,
                        "description": exclusionListSplit[index]
                    });
                }
            }
        }
        setResourceState(prevState => {
            let newCharacteristicArray = JSON.parse(JSON.stringify(prevState.characteristic));
            for (const characteristic of newCharacteristicArray) {
                if (!(characteristic.code.text === "Eligibility Criteria")) {
                    groupCharacteristicValue.push(characteristic);
                }
            }
            return {
                ...prevState,
                "characteristic": groupCharacteristicValue
            };
        });
    }

    return <div>
        <p>Keep the "Inclusion Criteria:" and "Exclusion Criteria:" headings, enter each criterion preceded by "* ".</p>
        <StringEntry elementName="markdown" fieldLabel="Inclusion/Exclusion Criteria"
            startingValue={criteriaListState.markdown} setResourceState={setCriteriaListState} />
        <Button className="formButton" style={{ color: "#000000" }}
            content="Convert this Eligibility Criteria to multiple Group.characteristic values"
            onClick={() => { createGroupCharacteristicValues(criteriaListState.markdown); }} />
        <p><b>AFTER CLICKING THIS BUTTON, Save All Changes THEN REFRESH THE PAGE</b></p>
    </div>
}

export default GroupCriteriaConverter;